import { moduleProviderFactory } from "mrb/core";
import { NakiStoreHomeSectionList, NakiStoreFeaturedSection } from "administration/naki-store/pages";
import {
    NakiStoreHomeSectionListRouteStore,
    NakiStoreFeaturedSectionRouteStore,
} from "administration/naki-store/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "NakiStore",
        routes: [
            {
                name: "master.administration.naki-store",
                pattern: "/naki-store",
                children: [
                    {
                        name: "master.administration.naki-store.sections",
                        pattern: "sections",
                        store: NakiStoreHomeSectionListRouteStore,
                        component: NakiStoreHomeSectionList,
                        data: {
                            title: "Home Screen Sections",
                        },
                    },
                    {
                        name: "master.administration.naki-store.featured-section",
                        pattern: "featured-section",
                        store: NakiStoreFeaturedSectionRouteStore,
                        component: NakiStoreFeaturedSection,
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.NAKI_STORE",
                order: 8,
                icon: "naki-store",
                subMenu: [
                    {
                        title: "ADMINISTRATION.MENU.NAKI_STORE_HOME_SCREEN",
                        order: 1,
                        route: "master.administration.naki-store.sections",
                    },
                    {
                        title: "ADMINISTRATION.MENU.NAKI_STORE_FEATURED_SECTION",
                        order: 2,
                        route: "master.administration.naki-store.featured-section",
                    },
                ],
            },
        ],
    });
})();
